import analytics from '@/shared-utils/analytics'

export type LogLtrModelVariantSearchParams = {
  searchQueryLength: number
  rankBy?: string
}

export default function logLtrModelVariantSearch({
  searchQueryLength,
  rankBy,
}: LogLtrModelVariantSearchParams) {
  analytics.log({
    message: 'usb_search_ltr_model_variant_search',
    experimentCode: 'USB_SEARCH_LTR_MODEL',
    searchQueryLength,
    rankBy: rankBy ?? null,
    isRelevance: rankBy === 'RELEVANCE',
  })
}
